import { saveAs } from "file-saver";

export const SettingMenuExport = {
  name: 'export',
  title: 'Import and Export',
  shortcut: 's'
};

export function downloadJSON(jsonString, filename) {
  var blob = new Blob([jsonString], {type: "application/json;charset=utf-8"});
  saveAs(blob, filename || "data.json");
}
export function downloadHTML(htmlObj, filename) {
  var blob = new Blob([htmlObj.html], {type: "text/html;charset=utf-8"});
  saveAs(blob, filename || "data.html");
  var blob2 = new Blob([htmlObj.css], {type: "text/css;charset=utf-8"});
  saveAs(blob2, filename.replace(/\.html$/,".css") || "data.css");
}